export default "Solutions de rénovation énergétique par type de bâtiment public : mairies, écoles, gymnases, piscines, EHPAD, éclairage public et réseaux de chaleur. Aides CEE et accompagnement.";
